import config from './config'
import { authHeader } from '@/_helpers'
import { localStore } from '@/_utils/localstore'

export const operatorService = {
  login,
  logout,
  getAll
}

async function login(username: string, password: string): Promise<any> {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ operator_name: username, password })
  }

  return fetch(`${config.apiUrl}/api/v1/auth`, requestOptions)
    .then(handleResponse)
    .then(response => {
      // login successful if there's a access_token in the response
      if (response.data && response.data.access_token) {
        // store user details and access_token in local storage to keep user logged in between page refreshes
        localStore.setItem('user', JSON.stringify(response.data))
      }

      return response
    }).catch((response) => {

      return Promise.reject(response)
    })
}

function logout() {
  // remove user from local storage to log user out
  localStore.removeItem('user')
}

function getAll(): Promise<any> {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/api/v1/operators`, requestOptions as any).then(
    handleResponse
  )
}

function handleResponse(response: any): any {
  return response.text().then((text: string) => {
    const data = text && JSON.parse(text)

    if (!response.ok) {
      const errorMsg = (data && data.message) || response.statusText
      return Promise.reject(errorMsg)
    }

    return data
  })
}
